import { Link } from 'react-router-dom';

export function FinancingOptions() {
  const examples = [
    {
      price: 20000,
      down: 2000,
      term: 60,
      rate: 6.99,
      payment: 356
    },
    {
      price: 25000,
      down: 2500,
      term: 60,
      rate: 6.99,
      payment: 445
    },
    {
      price: 30000,
      down: 3000,
      term: 72,
      rate: 7.49,
      payment: 445
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Affordable Monthly Payments
          </h2>
          <p className="text-lg text-gray-600">
            See how affordable a quality vehicle can be with our competitive financing rates
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12">
          {examples.map((example, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="text-center mb-4">
                <div className="text-3xl font-bold text-blue-600 mb-1">
                  ${example.payment}
                </div>
                <div className="text-sm text-gray-500">per month*</div>
              </div>
              <div className="border-t pt-4 space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Vehicle Price:</span>
                  <span className="font-semibold">${example.price.toLocaleString()}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Down Payment:</span>
                  <span className="font-semibold">${example.down.toLocaleString()}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Term:</span>
                  <span className="font-semibold">{example.term} months</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">APR:</span>
                  <span className="font-semibold">{example.rate}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-xl p-8 shadow-sm">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Financing Benefits</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                  <span>Multiple lenders competing for your business</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                  <span>Credit scores from 580+ accepted</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                  <span>Same-day approval available</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                  <span>No prepayment penalties</span>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Apply for Financing Today</h3>
              <p className="text-gray-600 mb-6">
                Get approved in minutes without affecting your credit score. Know your budget before you shop.
              </p>
              <Link
                to="/apply-for-financing"
                className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors w-full justify-center"
              >
                <i className="ri-calculator-line text-xl"></i>
                Apply for Financing
              </Link>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t text-xs text-gray-500">
            *Example payments shown for illustration purposes. Actual rates and terms vary based on credit history, down payment, and vehicle selection. APR ranges from 5.99% to 18.99%.
          </div>
        </div>
      </div>
    </section>
  );
}
